import { render, staticRenderFns } from "./KelasAktivitasButton.vue?vue&type=template&id=37089e21&"
import script from "./KelasAktivitasButton.vue?vue&type=script&lang=js&"
export * from "./KelasAktivitasButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports